import React, { Component } from "react";
import Select from "react-select";
import { PLAN_DISPLAY_NAMES, ENUM_MEMBERSHIP_PLANS } from "../../../config";
import { getCurrentReactSelectValue } from "../../../utils";

const options = ENUM_MEMBERSHIP_PLANS.map(name => ({
  value: name,
  label: PLAN_DISPLAY_NAMES[name]
}));

export default class SelectPlan extends Component {
  render() {
    return (
      <Select
        {...this.props}
        value={getCurrentReactSelectValue(this.props.value)}
        options={options}
      />
    );
  }
}
